import { List, ListItemText, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import styles from 'features/DefaultHelp.module.css';

const ControlsSection = () => {
    return (
        <div>
            <Typography variant="h4">CONTROLS</Typography>
            <Table className={styles['controls-table']}>
                <TableHead>
                    <TableRow>
                        <TableCell>Actions</TableCell>
                        <TableCell>Description</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <span>Location Selector</span>
                        </TableCell>
                        <TableCell>Choose the facility you want to monitor.</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>Access Point Records</span>
                        </TableCell>
                        <TableCell>Track all inbound and outbound gate activities at the facility over the past 7 days.</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <span>Appointments</span>
                        </TableCell>
                        <TableCell>View and manage upcoming vehicle appointments scheduled for today and the near future.</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>Authorization Lists</span>
                        </TableCell>
                        <TableCell>
                            Quickly check how many are currently authorized.
                            <List className={styles['unordered-list']}>
                                <ListItemText className={styles['list-item']}>People – Individuals allowed to access the yard.</ListItemText>
                                <ListItemText className={styles['list-item']}>
                                    Organizations – Partner companies with permission to operate in the facility.
                                </ListItemText>
                            </List>
                        </TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>Inventory</span>
                        </TableCell>
                        <TableCell>
                            Stay on top of your yard’s inventory health and ensure operational readiness.
                            <List className={styles['unordered-list']}>
                                <ListItemText className={styles['list-item']}>
                                    List – Summary of active trucks, trailers, and other asset types.
                                </ListItemText>
                                <ListItemText className={styles['list-item']}>
                                    Inventory Check – Track when the last inventory audit/check was done and how many items were reviewed.
                                </ListItemText>
                            </List>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
};

export default ControlsSection;
